import React from "react";
import ClientInfo from "./info/ClientInfo";

export const clientSidebarSections = [
  { id: 1, title: "dane pacjenta", component: <ClientInfo /> },
];
